import React, {Component}           from 'react';
import PropTypes                    from 'prop-types';
import translations                 from 'decorators/translations.js';
import configuredRadium             from 'configuredRadium.js';
import _                            from 'lodash';
import {
    initializeNewKey,
    initializeExistingKey,
    getValues
}                                   from 'helpers/formHelper.js';
import {
    MaterialTable,
    MaterialEdit,
    SystemSegmentEditButton,
    SystemFormWrapper,
    SystemFormBody,
    SystemFormActions,
    Button
}                                   from 'components';

const defaultKeys = [
    'description',
    'hours',
    'materialCost',
    'materialQuantity',
    'visits',
    'multiplier',
    'additionalDetails'
];

const idPrefix = "SystemMaterialContainer";

class SystemMaterialContainer extends Component {

    static propTypes = {
        system: PropTypes.object.isRequired,
        calculation: PropTypes.array,
        resetField: PropTypes.func.isRequired,
        handleCancel: PropTypes.func.isRequired,
        submitting: PropTypes.bool,
        handleSave: PropTypes.func.isRequired,
        isEditable: PropTypes.bool.isRequired
    };
    componentWillMount() {
        this.init(this.props.system);
    }

    componentWillReceiveProps(nextProps) {
        if(_.isEmpty(this.state.form) || (_.isEmpty(this.state.form.materials) && !_.isEmpty(nextProps.system.materials))) {
            this.init(nextProps.system);
        }
    }
    init(system) {
        const form = {
            materials: []
        };
        if(system.materials && _.isArray(system.materials)) {
            system.materials.map((material, index) => {
                const obj = initializeExistingKey({keys: defaultKeys, values: material, index, changeValue: this.changeValue});
                form.materials.push(obj);
            });
        }
        this.setState({form});
    }
    getForm() {
        return Object.assign({}, this.state.form);
    }
    changeValue = (value, index, key) => {
        const form = this.getForm();
        form.materials[index][key].value = value;
        if(['hours', 'visits', 'multiplier', 'materialCost', 'materialQuantity'].indexOf(key) !== -1) {
            const sys = Object.assign({}, this.props.system);
            if(!sys.materials) {
                sys.materials = [];
            }
            form.materials.map((material, idx) => {
                const obj = getValues(material);
                if(!sys.materials[idx]) {
                    sys.materials.push(obj);
                } else {
                    sys.materials[idx] = obj;
                }
            });
            this.props.calculateCosts(sys);
        }
        this.setState({form});
    };
    isDataValid(data) {
        return data && data.length > 0 && !this.props.editMode;
    }
    remove = (index) => {
        this.setState({removed: true});
        const form = this.getForm();
        form.materials.splice(index, 1);
        this.setState({form});
    };
    add = () => {
        const form = this.getForm();
        const newRow = initializeNewKey({defaultKeys, index: (form.materials.length), changeValue: this.changeValue});
        form.materials.push(newRow);
        this.setState({form});
    };
    cancel = () => {
        this.init(this.props.system);
        this.props.handleCancel();
    };
    handleSave = () => {
        const form = this.getForm();
        const system = this.props.system;
        system.materials = [];
        form.materials.map((row) => {
            const tmp = getValues(row);
            system.materials.push(tmp);
        });
        this.props.handleSave(system);
    };
    expandArea = () => {
        if(!this.state.removed && this.state.form.materials && this.state.form.materials.length === 0 && this.props.isEditable) {
            this.add();
            this.props.systemSegmentEditAction();
        }
        this.setState({expandThis: !this.state.expandThis});
    };

    renderNotEditable = () => {
        const { t, showEditButton, isEditable } = this.props;

        return (
            <div>
                <SystemSegmentEditButton
                    onClick = {this.props.systemSegmentEditAction}
                    showEditButton = {showEditButton}
                    editText = {this.state.form.materials && this.state.form.materials.length > 0 ? t('edit') : t('add_materials')}
                    isEditable = {isEditable}
                />
                <MaterialTable
                    materials={ this.props.system.materials || [] }
                    calculation={ this.props.calculatedSystem ? this.props.calculatedSystem.materials : [] }
                />
            </div>
        );
    }

    renderEditable = () => {
        const { submitting } = this.props;

        return (
            <div>
                <MaterialEdit
                    form={ this.state.form }
                    calculation={ this.props.calculatedSystem ? this.props.calculatedSystem.materials : [] }
                    removeMaterialAction={ this.remove }
                    resetFunction={ this.props.resetField.bind(this) }
                    calculating = {this.props.calculating}
                />
                <SystemFormActions
                    submitting={ submitting }
                    handleSave={ this.handleSave }
                    handleCancel={ this.cancel }
                    idPrefix={ idPrefix }
                >
                    <Button
                        variant="add"
                        onClick={ this.add }
                    >+ { this.props.t('add_materials') }
                    </Button>
                </SystemFormActions>
            </div>
        )
    }

    render() {
        const {t, calculatedSystem} = this.props;
        const editMode = this.props.editMode;
        const expandThis = editMode ? true : this.state.expandThis;
        const isValid = this.isDataValid(this.state.form.materials);
        let sum = 0;
        if (calculatedSystem && calculatedSystem.materials) {
            this.props.calculatedSystem.materials.map((row) => {
                sum += (row.cost || 0);
            });
        }
        return (
            <SystemFormWrapper
                id={ idPrefix + '_title' }
                isVisible={ expandThis }
                handleToggle={ this.expandArea }
                title={ t('title_materials') }
                cost={ sum }
                isValid={ isValid }
            >
                <SystemFormBody
                    notEditableBody={ this.renderNotEditable() }
                    editableBody={ this.renderEditable() }
                    isEditable={ editMode }
                />
            </SystemFormWrapper>
        );
    }
}

export default translations(configuredRadium(SystemMaterialContainer));
